import  {Component} from 'react';
import axios from "axios";
import {apiConfigs,headers } from '../Config';
class Api extends Component {
    constructor(props) {
        super(props);
        axios.defaults.baseURL = apiConfigs.baseURL;
        axios.defaults.timeout = 1000000;
    }

    // Login Page
    signUp = (request) =>{
        return  axios.post( 'sign-up', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    // Verify OTP Page
    signIn = (mobile , otp) =>{
       return  axios.post( 'sign-in', {mobile , otp}, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //  Register Page
    updateProfile = (request) =>{
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }

        return  axios.post( 'users/update-profile', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    getUserInfo = (params = null) => {
        return axios.get( `users/profiles/info`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getContent = (slug) => {
        return axios.get( `contents/${slug}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }



    //Orders History Page
    getOrders = (params = null) => {
        return axios.get( `orders`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //Order  Detail  Page
    getOrder = (params = null , id) => {
        return axios.get( `orders/${id}`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    updateStatus = (request) =>{
        return  axios.patch( 'update-order-status', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //Vendor Page
    getVendors = (params = null) => {
        return axios.get( `products/vendors`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getStatuses = (params = null) => {
        return axios.get( `statuses`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getDevices = (params = null) => {
        return axios.get( `vehicles/get-devices`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getCheckList = (params = null) => {
        return axios.get( `guard-checklist`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }




    storeOrder = (request) =>{
        return  axios.post( 'orders', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    storeVendor = (request) =>{
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
        return  axios.post( 'products/vendors', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    updateVendor = (request) =>{
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
        return  axios.post( 'products/update-vendor', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    editOrder = (request,id) =>{
        return  axios.put( `orders/${id}`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    uploadFile = (request,id) =>{

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }

        return  axios.post( `products/import`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    uploadFileReturnByExcel = (request,id) =>{

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }

        return  axios.post( `products/return-excel`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    uploadFileReturn = (request,id) =>{

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }

        return  axios.post( `orders/import-return-batteries`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    productExcelReport = (request ,excel) =>{

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }

        return  axios.post( `reports/products-excel`, request, {
            headers,
            responseType:  excel > 0 ?'arraybuffer' : null,
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    productSpecialExcelReport = (request ,excel) =>{

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }

        return  axios.post( `reports/special-products-excel`, request, {
            headers,
            responseType:  excel > 0 ?'arraybuffer' : null,
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    productionProductExcelReport = (request ,excel) =>{

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }

        return  axios.post( `reports/products-production-excel`, request, {
            headers,
            responseType:  excel > 0 ?'arraybuffer' : null,
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    productProductionExcelReport = (request ,excel) =>{

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }

        return  axios.post( `reports/products-excel-production`, request, {
            headers,
            responseType:  excel > 0 ?'arraybuffer' : null,
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
     uploadTracking = (request ,excel) =>{

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }

        return  axios.post( `products/upload-tracking`, request, {
            headers,
            responseType:  excel > 0 ?'arraybuffer' : null,
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    removeFile = (id) =>{


        return  axios.delete( `orders/remove-document/${id}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getUsers = (params = null) => {
        return axios.get( `users/profiles`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getAgents = (params = null) => {
        return axios.get( `reports/agents`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getProductReport = (params = null) => {
        return axios.get( `reports/products-export`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getProductReportExcel = (params = null) => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Authorization': 'Bearer ' + token,
        }
        return axios.get( `reports/products-export`, {
            headers,
            params,
            responseType: 'arraybuffer',
        })
            .then(response => {
                return response;
            })
            .catch((error) => {
                throw error;
            });
    }
    getProductProductionReport = (params = null) => {
        return axios.get( `reports/product-production-process`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getProductProductionReportExcel = (params = null) => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Authorization': 'Bearer ' + token,
        }
        return axios.get( `reports/product-production-process`, {
            headers,
            params,
            responseType: 'arraybuffer',
        })
            .then(response => {
                return response;
            })
            .catch((error) => {
                throw error;
            });
    }



    // Brand Reports
    getBrandReport = (params = null) => {


        return axios.get( `reports/sale-return-dates-brands`, {
            headers,
            params,
            responseType:  params.excel > 0 ?'arraybuffer' : null,
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }



    getBrandMonthReport = (params = null) => {
        return axios.get( `reports/sale-return-month-brands`, {
            headers,
            params,
            responseType:  params.excel > 0 ?'arraybuffer' : null,
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    // Vendor Reports
    getVendorReport = (params = null) => {
        return axios.get( `reports/sale-return-dates-vendors`, {
            headers,
            params,
            responseType:  params.excel > 0 ?'arraybuffer' : null,

        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getVendorMonthReport = (params = null) => {
        return axios.get( `reports/sale-return-month-vendors`, {
            headers,
            params,
            responseType:  params.excel > 0 ?'arraybuffer' : null,
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getBasics = (params = null) => {

        return axios.get( `products/get-basics`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getProduct = (code) => {

        return axios.get( `reports/product/${code}`, {
             headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getDetails = (orderId) => {
        return axios.get( `orders/get-details/${orderId}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getProducts = (params = null ) => {
        return axios.get( `products/products`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    // BackSale
    storeBOrder = (request = null) =>{
        return  axios.post( 'back-sales', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    updateBOrder = (request = null , id) =>{
        return  axios.patch( `back-sales/${id}`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    // returned
    storeROrder = (request = null) =>{
        return  axios.post( 'orders/store-returned', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    // Return Requests (نماینده UPS)
    searchReturnOrder = (params = null) => {
        return axios.get( `return-requests/search`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    storeReturnRequest = (request = null) => {
        return axios.post( 'return-requests', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getReturnRequests = (params = null) => {
        return axios.get( `return-requests`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
}
const API = new Api();
export default API;